export enum promoCodesFormFields {
  name = 'name',
  code = 'code',
  maxUses = 'maxUses',
  type = 'type',
  isActive = 'isActive',
  expirationDate = 'expirationDate',
  // associatedPartner = 'associatedPartner'
}
